/**
 * IMPORTANT: The widget rendering system has been decommissioned.
 *
 * This file is maintained only to prevent breaking imports in existing third-party customizations.
 * New code should not use this component or the widget system.
 */

/**
 * This class is kept only for backward compatibility.
 *
 * @deprecated This class is part of the decommissioned widget system and should not be used anymore.
 */
export const WidgetDropdownHeaderClass = {
  /**
   * @deprecated the widget rendering system was decommissioned
   */
  transform() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildAttributes() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildClasses() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  click() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  _buildLabel() {},
};

/**
 * This class is kept only for backward compatibility.
 *
 * @deprecated This class is part of the decommissioned widget system and should not be used anymore.
 */
export const WidgetDropdownItemClass = {
  /**
   * @deprecated the widget rendering system was decommissioned
   */
  transform() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildAttributes() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildClasses() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  keyDown() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  click() {},
};

/**
 * This class is kept only for backward compatibility.
 *
 * @deprecated This class is part of the decommissioned widget system and should not be used anymore.
 */
export const WidgetDropdownBodyClass = {
  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildClasses() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  clickOutside() {},
};

/**
 * This class is kept only for backward compatibility.
 *
 * @deprecated This class is part of the decommissioned widget system and should not be used anymore.
 */
export const WidgetDropdownClass = {
  /**
   * @deprecated the widget rendering system was decommissioned
   */
  init() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildKey() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildAttributes() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  defaultState() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildClasses() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  transform() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  hideBody() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  _onChange() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  destroy() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  willRerenderWidget() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  didRenderWidget() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  _onTrigger() {},
};

export { DummyWidget as default } from "discourse/widgets/widget";
